import React, { useEffect, useState } from 'react'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import { styled, useTheme } from '@mui/material/styles'
import { Avatar, Box } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email';
import { useSelector } from 'react-redux'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const TriangleImg = styled('img')({
    right: 0,
    bottom: 0,
    height: 170,
    position: 'absolute'
  })
  
  // Styled component for the trophy image
  const TrophyImg = styled('Avatar')({
    right: 36,
    bottom: 20,
    height: 98,
    position: 'absolute'
    
  })

  const Rectangle163 = styled("Card")({
    backgroundColor: `rgba(255, 255, 255, 1)`,
    boxShadow: `0px 0px 15px rgba(0, 0, 0, 0.05)`,
    borderRadius: `34px`,
    //width: `488px`,
    //height: `282px`,
    //position: `absolute`,
    width: '100%', // Set the width to 90% of the parent container
    height: '100%', // Automatically adjust the height based on content
    margin: '0 auto', // Center the card horizontally
    padding: '16px',
    //left: `0px`,
   // top: `0px`,
  });

  const Icon = styled("img")({
    display: `flex`,
    //position: `absolute`,
    //isolation: `isolate`,
    flexDirection: `row`,
    justifyContent: `flex-start`,
    alignItems: `flex-start`,
    padding: `0px`,
    boxSizing: `border-box`,
    width: `18px`,
    height: `18px`,
  });

  /*function stringAvatar(name) {
    return {
      sx: {
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }*/

  

function TrainerProfileCard() {
    const { trainerId } = useSelector((state) => state.user);
  const [ trainerData, setTrainerData] = useState([])
   

    useEffect(() => {
        fetch(`${API_ENDPOINT}trainer/${trainerId}`)
        .then(res => res.json())
        .then(data => {
          setTrainerData(data)
        })
    }, []);


  const stringAvatar = (data) => {
    if (data.image && data.image.type === 'Buffer' && data.image.data.length > 0) {
        const dataArray = data.image.data; // Get the array of numbers from the image data
        const uint8Array = new Uint8Array(dataArray); // Create a Uint8Array from the array of numbers
        const imageBlob = new Blob([uint8Array], { type: 'image/jpeg' }); // Create a Blob from the Uint8Array
        const imageUrl = URL.createObjectURL(imageBlob); 

      return {
        src: imageUrl,
        sx: {
          width: 129,
          height: 129,
        },
      };
    } else {
      return {
        sx: {
          width: 129,
          height: 129,
        },
        children: `${data.full_name?.split(' ')[0][0]}${data.full_name?.split(' ')[1][0]}`,
      };
    }
  };

  //const { full_name, email, image, location, mobile_number} = trainerData
  return (
    
    <Rectangle163 >
    <CardContent>
        <Box container spacing={2} sx={{display: 'flex'}}>
        <Box>
    <Avatar {...stringAvatar(trainerData)} sx={{height: '129px', width: '129px'}}/>
    </Box>
    <Box  sx={{marginLeft: '20px'}}>
      <Typography variant='h4'>{trainerData.full_name }</Typography>
        <Box mt={2} sx={{display: 'flex'}}>
            <Icon alt='email-icon' src={'/wetransfer_add-enquiry-svg_2023-07-25_1047/mail.svg'}></Icon>
      <Typography variant='body2' sx={{ letterSpacing: '0.25px' }}>
        {trainerData.email}
      </Typography>
      </Box>
      <Box sx={{display: 'flex'}} mt={2}>
            <Icon alt='call-icon' src={'/wetransfer_add-enquiry-svg_2023-07-25_1047/Phone.svg'}></Icon>
      <Typography variant='body2' sx={{ letterSpacing: '0.25px' }}>
        {trainerData.mobile_number }
      </Typography>
      </Box>
      <Box sx={{display: 'flex'}} mt={2}>
            <Icon alt='location-icon' src={'/wetransfer_add-enquiry-svg_2023-07-25_1047/Location.svg'}></Icon>
      <Typography variant='body2' sx={{ letterSpacing: '0.25px' }}>
        {trainerData.location || 'Location not available'}
      </Typography>
      </Box>
      </Box>
      </Box>
    </CardContent>
  </Rectangle163>
  )
}

export default TrainerProfileCard